var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 13.5002C2.00736 13.5002 1 12.4928 1 11.2502V3.75002C1 2.50737 2.00736 1.5 3.25 1.5H10.75C11.9926 1.5 13 2.50737 13 3.75002L13 11.2502C13 12.4928 11.9926 13.5002 10.75 13.5002H3.25Z",
    fill: "#25C277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 6.00004L5.89398 9.00007L4.75 7.97744M13 3.75002L13 11.2502C13 12.4928 11.9926 13.5002 10.75 13.5002H3.25C2.00736 13.5002 1 12.4928 1 11.2502V3.75002C1 2.50737 2.00736 1.5 3.25 1.5H10.75C11.9926 1.5 13 2.50737 13 3.75002Z",
    stroke: "white",
    strokeWidth: 1.50001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.ba17c5f4de53ddc88bf7574d5de30380.svg";
export { ForwardRef as ReactComponent };